import { Action } from '@reduxjs/toolkit';

import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { call, put, takeLatest } from 'redux-saga/effects';
import { ILinkPaymentSearchModel, LinkPaymentSearchModelInit, LinkPaymentSearchResponseModel } from '../models';
import { linkPaymentSearch } from './LinkPaymentCrud';

export interface ActionWithPayload<T> extends Action {
    payload?: T;
}

export const actionTypes = {
    SetLinkPaymentList: '[SetLinkPaymentList] Action',
    SetLinkPaymentFind: '[SetLinkPaymentFind] Action',
};

export interface ILinkPaymentState {
    linkPaymentList?: LinkPaymentSearchResponseModel;
    linkPaymentFind?: ILinkPaymentSearchModel;
}

const initialLinkPaymentState: ILinkPaymentState = {
    linkPaymentList: undefined,
    linkPaymentFind: undefined,
};

export const reducer = persistReducer(
    { storage, key: 'kpmrc-linkpayment', whitelist: ['linkPaymentList', 'linkPaymentFind'] },
    (state: ILinkPaymentState = initialLinkPaymentState, action: ActionWithPayload<ILinkPaymentState>) => {
        switch (action.type) {
            case actionTypes.SetLinkPaymentList: {
                const linkPaymentList = action.payload?.linkPaymentList;
                return { ...state, linkPaymentList };
            }
            case actionTypes.SetLinkPaymentFind: {
                const linkPaymentFind = action.payload?.linkPaymentFind;
                return { ...state, linkPaymentFind };
            }

            default:
                return state;
        }
    }
);

export const actions = {
    setLinkPaymentList: (linkPaymentList: LinkPaymentSearchResponseModel) => ({ type: actionTypes.SetLinkPaymentList, payload: { linkPaymentList } }),
    setLinkPaymentFind: (linkPaymentFind: ILinkPaymentSearchModel) => ({ type: actionTypes.SetLinkPaymentFind, payload: { linkPaymentFind } }),
};

export function* saga() {
    yield takeLatest(actionTypes.SetLinkPaymentFind, function* setLinkPaymentFindSaga(action: ActionWithPayload<ILinkPaymentState>) {
        try {
            var searchParams = action.payload?.linkPaymentFind ?? new LinkPaymentSearchModelInit();
            const { data: linkPayments } = yield call(linkPaymentSearch, searchParams);
            yield put(actions.setLinkPaymentList(linkPayments.data));
        } catch (error) {
            console.error("LinkPayment Saga Error:", error);
        }
    });
}